<template>
  <div v-loading="showFlag">
    <t-card class="card_common">
      <div>
        <!-- ボタン -->
        <t-row>
          <t-col :span="8" class="col_common_center">
            <!-- 新規 -->
            <t-button
              round
              type="primary"
              class="button_common"
              ref="addBtn"
              @click="addClick()"
            >
              <i class="el-icon-plus"></i>
              {{ $t("resource.sys.newBuilt") }}
            </t-button></t-col
          ><t-col :span="8" class="col_common_center">
            <!-- 削除 -->
            <t-button
              round
              type="danger"
              class="button_common"
              ref="delBtn"
              @click="deleteClick"
            >
              <i class="el-icon-delete"></i>
              {{ $t("resource.sys.delete") }}
            </t-button></t-col
          >
        </t-row>

        <!-- 検索条件 -->
        <div class="div_common_search">
          <t-divider>{{ $t("resource.sys.searchCondition") }}</t-divider>
          <div class="search">
            <t-form
              :model="searchConditionForm"
              :label-width="
                $t('widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY_PX')
              "
            >
              <t-row>
                <t-col :span="1">&nbsp;</t-col>
                <t-col :span="10">
                  <div>
                    <!-- 取込日 -->
                    <t-form-item
                      :label="$t('resource.DATA_IMPORT.IMPORT_DATE')"
                    >
                      <t-date-picker
                        v-model="dateRange"
                        type="daterange"
                        range-separator="～"
                        start-placeholder="開始日"
                        end-placeholder="終了日"
                        value-format="yyyy-MM-dd"
                        style="min-width: 20px; width: 75%; margin-top: 8px"
                        :clearable="false"
                        class="date_icon_center"
                        format="yyyy/MM/dd"
                        :editable="false"
                      >
                      </t-date-picker>
                    </t-form-item>
                  </div>
                </t-col>
                <t-col :span="1">&nbsp;</t-col>
                <t-col :span="5">
                  <!-- 取込担当者 -->
                  <t-form-item :label="$t('resource.DATA_IMPORT.CONTACTER')">
                    <t-select
                      v-model="searchConditionForm.userCode"
                      clearable
                      style="width: 100%"
                      :placeholder="$t('resource.sys.hidden')"
                    >
                      <t-option
                        v-for="item in userList"
                        :key="item.UserId"
                        :label="item.UserName"
                        :value="item.UserId"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>
                <t-col :span="5">
                  <!-- 状態 -->
                  <t-form-item :label="$t('resource.DATA_IMPORT.STATUS')">
                    <t-select
                      v-model="searchConditionForm.acceptState"
                      clearable
                      style="width: 100%"
                      :placeholder="$t('resource.sys.hidden')"
                    >
                      <t-option
                        v-for="item in statusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>
                <t-col :span="2">&nbsp;</t-col>
              </t-row>
              <t-row>
                <t-col :offset="1" :span="16" class="col_block_left">
                  <!-- 検索キー -->
                  <t-form-item :label="$t('resource.sys.searchKey')">
                    <t-input
                      v-model="searchConditionForm.searchWord"
                      class="input_searchKey"
                      maxLength="50"
                      clearable
                    >
                    </t-input>
                  </t-form-item>
                </t-col>
                <t-col :span="1">&nbsp;</t-col>
                <t-col :span="4" class="right">
                  <!-- 検索 -->
                  <t-button
                    round
                    type="primary"
                    class="button_common_search"
                    ref="searchBtn"
                    @click="searchClick()"
                  >
                    <i class="el-icon-search"></i
                    >{{ $t("resource.sys.search") }}
                  </t-button>
                </t-col>
                <t-col :span="2">&nbsp;</t-col>
              </t-row>
            </t-form>
          </div>
        </div>
      </div>

      <div class="div_content">
        <t-table
          ref="dataImportTableData"
          :data="tableData"
          class="table_common"
          header-cell-class-name="bg-default"
          @row-dblclick="detailClick"
          :height="maxheight"
          border
        >
          <t-table-column type="selection" class-name="cell_txt_center" />
          <!-- 状態 -->
          <t-table-column
            prop="dibAcceptState"
            :label="$t('resource.DATA_IMPORT.STATUS')"
            :min-width="
              flexColumnWidthFunc(
                $t('resource.DATA_IMPORT.STATUS'),
                'dibAcceptState'
              )
            "
            class-name="cell_txt_center"
          >
            <template #default="{ row }"
              ><div class="div_status">
                <span :class="formatStatusColor(row)" class="status">●</span>
                <span class="quote-state">{{ row.dibAcceptState }} </span>
              </div>
            </template>
          </t-table-column>

          <t-table-column
            v-for="(column, index) in columns"
            :key="index"
            :type="column.type"
            :prop="column.prop"
            :label="column.label"
            :min-width="column.width"
            :class-name="column.class"
            :show-overflow-tooltip="column.overflowTooltip"
          >
          </t-table-column>
        </t-table>
        <t-pagination
          align="right"
          :current-page.sync="pageNo"
          :page-size="pageSize"
          :page-sizes="getPageDataCountFunc()"
          layout="total, sizes, prev, pager, next"
          :total="dataImportTableDataLength"
          @current-change="pageChange"
          @size-change="handleSizeChange"
        >
        </t-pagination>
      </div>
    </t-card>
  </div>
</template>
<script>
import { getUserInfo } from "@/auth";
import { ShowDataImportEditDialog } from "@/components/Dialog";
import { t } from "@/locales";
import {
  deleteDataImportBasicInfo,
  getDataImportBasicInfo,
  initDataImportSearchList,
} from "@/services/dataImport";
import {
  formatDateToString,
  formatDateToyyyyMMddHHmmss,
  getAbleUserInfoList,
  getPreviousMonthDate,
} from "@/utils/comFunction";
import { DIB_ACCEPT_ORDER_WAITING, GetPageDataCount } from "@/utils/const";
import { flexColumnWidth, setColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";

export default {
  data() {
    return {
      dateRange: [],

      searchConditionForm: {
        startQuoteDate: "",
        endQuoteDate: "",
        userCode: "",
        acceptState: "",
        searchWord: "",
      },

      //一覧表のデータ
      dataImportTableData: [],
      //担当者
      userList: [],
      //受注状態
      statusList: [],

      columns: [
        //取込時間
        {
          prop: "dibImportTime",
          label: t("resource.DATA_IMPORT.IMPORT_TIME"),
          width: t("widgetSize.tableCommon.width170"),
          class: "cell_txt_center",
        },
        //担当者
        {
          prop: "dibUserCode",
          label: t("resource.DATA_IMPORT.CONTACTER"),
          width: t("widgetSize.tableCommon.width170"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        //ファイル名
        {
          prop: "dibFileName",
          label: t("resource.DATA_IMPORT.FILE_NAME"),
          width: 4 * Number(t("widgetSize.tableCommon.width170")),
          class: "cell_txt_left",
        },
      ],
      //現在のページ数
      pageNo: 1,
      //データ個数/各ページ
      pageSize: 20,
      dataImportTableDataLength: 0,
      maxheight: window.innerHeight - 291.5 - 10, //291.5 = 165.5 + 20 + 10 + 58 + 32 + 6

      //カバー層のフラップ false:表示しない
      showFlag: false,
    };
  },

  mounted() {
    this.showFlag = true;

    //画面の初期化
    this.init();

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);

    setColumnWidth(this.columns, this.dataImportTableData);
  },

  computed: {
    tableData() {
      return this.dataImportTableData.slice(
        (this.pageNo - 1) * this.pageSize,
        this.pageNo * this.pageSize
      );
    },
  },

  methods: {
    //テーブルの高さを設定する
    handleResize() {
      this.maxheight = window.innerHeight - 291.5 - 10; //291.5 = 165.5 + 20 + 10 + 58 + 32 + 6
    },

    //状態背景色
    formatStatusColor(row) {
      return this.statusList.find((it) => it.label === row.dibAcceptState)
        ?.statusColor;
    },

    //初期化
    init() {
      //取込日初期化
      this.dateInit();

      //取込担当者＝ログインユーザ
      this.searchConditionForm.userCode = getUserInfo().UserId;
      //検索条件リストの初期化(取込担当者、受注状態)
      initDataImportSearchList()
        .then((res) => {
          this.$nextTick(() => {
            //担当者
            this.userList = [];
            res.userList.forEach((item) => {
              this.userList.push({
                UserName: item.UserName,
                UserId: item.UserId,
                Contraction: item.Contraction,
                DeleteFlg: item.DeleteFlg,
              });
            });

            //ログインユーザの省略字が空の場合、取込担当者が空を変更する
            if (
              !this.userList.some(
                (user) => user.UserId == this.searchConditionForm.userCode
              )
            ) {
              this.searchConditionForm.userCode = "";
            }

            //受注状態
            this.statusList = res.searchStatus;

            //検索処理
            this.searchClick();
          });
          //使用可能な担当者リストの取得
          //this.getAbleList();
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        });
    },

    //使用可能な担当者リストの取得
    getAbleList() {
      //担当者リスト
      this.userList = getAbleUserInfoList(
        this.userList,
        this.searchConditionForm.userCode
      );
    },

    //取込日の初期化
    dateInit() {
      //システム日付
      var systemDate = new Date();

      //日付初期値の設定:取込日(開始～終了)
      this.dateRange = [getPreviousMonthDate(systemDate), systemDate];
    },

    //検索
    searchClick() {
      //検索条件の調整
      this.updateSearchForm();

      //検索受注データ取込台帳基本情報
      getDataImportBasicInfo(this.searchConditionForm)
        .then((res) => {
          this.dataImportTableData = res;
          this.dataImportTableDataLength = res.length;
          Message.showSuccess(t("message.COMMON_MESSAGE.SEARCH_SUCCESS"));

          //データ処理
          this.dataProcess();

          setColumnWidth(this.columns, this.dataImportTableData);
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })
        .finally(() => {
          this.showFlag = false;
          //フォーカス削除
          this.$refs.searchBtn.$el.blur();
        });
    },

    //検索条件の調整
    updateSearchForm() {
      //取込日が空でない場合
      if (this.dateRange) {
        //取込日(開始)
        this.searchConditionForm.startQuoteDate = formatDateToString(
          this.dateRange[0]
        );

        //取込日(終了)
        this.searchConditionForm.endQuoteDate =
          formatDateToString(this.dateRange[1]) + " 23:59:59";
      } else {
        this.searchConditionForm.startQuoteDate = "";
        this.searchConditionForm.endQuoteDate = "";
      }

      //スペースを削除
      this.searchConditionForm.searchWord =
        this.searchConditionForm.searchWord.trim();
    },

    //複数行データの削除
    deleteClick() {
      let data = this.$refs.dataImportTableData.selection;
      var deleteFlg = true;

      if (data.length >= 1) {
        let delList = [];
        for (let index = 0; index < data.length; index++) {
          //受注状態値の取得
          var dibAcceptState = this.statusList.find(
            (it) => it.label === data[index].dibAcceptState
          )?.value;

          //「受注待ち」以外データが削除不可
          if (dibAcceptState != DIB_ACCEPT_ORDER_WAITING) {
            Modal.showError("", t("message.DATA_IMPORT.NOT_DELETE"), {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            });
            deleteFlg = false;
            break;
          }

          delList.push(data[index].dibNo);
        }

        //削除可能の場合
        if (deleteFlg) {
          Modal.showWarning("", t("resource.sys.deleteMessage"), {
            $type: "prompt",
            confirmButtonText: t("resource.button.sure"),
            cancelButtonText: t("resource.button.cancel"),
            showCancelButton: true,
          }).then(() => {
            //削除受注データ取込基本情報
            deleteDataImportBasicInfo({
              delList: delList,
              user: getUserInfo().UserId,
            })
              .then(() => {
                Message.showSuccess(t("message.COMMON_MESSAGE.DELETE_SUCCESS"));
              })
              .catch((err) => {
                this.showFlag = false;
                if (err.data != null) {
                  Message.showError(
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                  );
                } else {
                  Message.showError(t("message.COMMON_MESSAGE.DELETE_FAILURE"));
                }
              })
              .finally(() => {
                //検索処理を行う
                this.searchClick();
              });
          });
        }
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }
      //フォーカス削除
      this.$refs.delBtn.$el.blur();
    },

    //新規
    addClick() {
      //新规
      ShowDataImportEditDialog(
        { isAdd: true },
        t("resource.DATA_IMPORT.DATA_IMPORT_DETAIL"),
        (target) => {
          this.searchClick();
          //this.searchConditionForm.searchWord = target;
        }
      );
      //フォーカス削除
      this.$refs.addBtn.$el.blur();
    },

    //詳細
    detailClick(row, column, cell, event) {
      //編集
      ShowDataImportEditDialog(
        { isAdd: false, rowData: row },
        t("resource.DATA_IMPORT.DATA_IMPORT_DETAIL"),
        (target) => {
          this.showFlag = false;
          this.searchClick();
          //this.searchConditionForm.searchWord = target;
        }
      );
    },

    //データの処理
    dataProcess() {
      this.dataImportTableData.map((item) => {
        //取込時間の変換
        item.dibImportTime = formatDateToyyyyMMddHHmmss(item.dibImportTime);

        //受注状態の変換
        item.dibAcceptState = this.statusList.find(
          (it) => it.value === item.dibAcceptState
        )?.label;
        return item;
      });
    },

    pageChange(val) {
      this.pageNo = val;
    },

    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
    },

    getPageDataCountFunc() {
      return GetPageDataCount();
    },

    //アダプティブ列幅
    flexColumnWidthFunc(label, prop) {
      return flexColumnWidth(label, prop, this.dataImportTableData);
    },
  },
};
</script>
<style lang="scss" scope>
.quote-state {
  flex: 1; /* 残りのスペースを2番目のspan要素に占有させ、コンテンツの配置を実現 */
}
</style>
